import { NgModule } from '@angular/core';
import { BmsjHipsterSharedModule } from '../../../shared';
import { RouterModule } from '@angular/router';
import { GERMPLASM_BASIC_DETAILS_ROUTES } from './germplasm-basic-details.route';
import { EditGermplasmBasicDetailsPopupComponent, GermplasmBasicDetailsModalComponent } from './germplasm-basic-details-modal.component';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild([...GERMPLASM_BASIC_DETAILS_ROUTES]),
    ],
    declarations: [
        GermplasmBasicDetailsModalComponent,
        EditGermplasmBasicDetailsPopupComponent
    ]
})
export class GermplasmBasicDetailsModule {

}
